/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolEnum } from './ProtocolEnum';
import {
    ProtocolEnumFromJSON,
    ProtocolEnumFromJSONTyped,
    ProtocolEnumToJSON,
    ProtocolEnumToJSONTyped,
} from './ProtocolEnum';
import type { StateEnum } from './StateEnum';
import {
    StateEnumFromJSON,
    StateEnumFromJSONTyped,
    StateEnumToJSON,
    StateEnumToJSONTyped,
} from './StateEnum';

/**
 * 
 * @export
 * @interface Port
 */
export interface Port {
    /**
     * 
     * @type {number}
     * @memberof Port
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Port
     */
    number: number;
    /**
     * 
     * @type {ProtocolEnum}
     * @memberof Port
     */
    protocol?: ProtocolEnum;
    /**
     * 
     * @type {StateEnum}
     * @memberof Port
     */
    state?: StateEnum;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    service?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    screenshot?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    banner?: string | null;
    /**
     * 
     * @type {any}
     * @memberof Port
     */
    headers?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof Port
     */
    readonly lastSeen: Date;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    readonly technologies: string;
    /**
     * 
     * @type {string}
     * @memberof Port
     */
    readonly linkedObject: string;
    /**
     * 
     * @type {number}
     * @memberof Port
     */
    statusCode?: number;
}



/**
 * Check if a given object implements the Port interface.
 */
export function instanceOfPort(value: object): value is Port {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('lastSeen' in value) || value['lastSeen'] === undefined) return false;
    if (!('technologies' in value) || value['technologies'] === undefined) return false;
    if (!('linkedObject' in value) || value['linkedObject'] === undefined) return false;
    return true;
}

export function PortFromJSON(json: any): Port {
    return PortFromJSONTyped(json, false);
}

export function PortFromJSONTyped(json: any, ignoreDiscriminator: boolean): Port {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'protocol': json['protocol'] == null ? undefined : ProtocolEnumFromJSON(json['protocol']),
        'state': json['state'] == null ? undefined : StateEnumFromJSON(json['state']),
        'service': json['service'] == null ? undefined : json['service'],
        'version': json['version'] == null ? undefined : json['version'],
        'title': json['title'] == null ? undefined : json['title'],
        'screenshot': json['screenshot'] == null ? undefined : json['screenshot'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'headers': json['headers'] == null ? undefined : json['headers'],
        'lastSeen': (new Date(json['last_seen'])),
        'technologies': json['technologies'],
        'linkedObject': json['linked_object'],
        'statusCode': json['status_code'] == null ? undefined : json['status_code'],
    };
}

  export function PortToJSON(json: any): Port {
      return PortToJSONTyped(json, false);
  }

  export function PortToJSONTyped(value?: Omit<Port, 'id'|'last_seen'|'technologies'|'linked_object'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'protocol': ProtocolEnumToJSON(value['protocol']),
        'state': StateEnumToJSON(value['state']),
        'service': value['service'],
        'version': value['version'],
        'title': value['title'],
        'screenshot': value['screenshot'],
        'banner': value['banner'],
        'headers': value['headers'],
        'status_code': value['statusCode'],
    };
}

